import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import getters from './getters'
import mutations from './mutations'
import user from './modules/user'
import filterGroup from './modules/filterGroup'
import headerMenu from './modules/headerMenu'
import headerSearch from './modules/headerSearch'

Vue.use(Vuex)

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  modules: {
    user,
    headerSearch,
    headerMenu,
    filterGroup
  }
})

export default store